import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core';
import LoaderPopUp from '../loaderpopup/loader';
import { CommonConfig } from '../../config/common-config';
import { DeleteEmp } from '../../modules/core/deleteEmployee/common/view/index';

const useStyles = makeStyles((theme) => ({
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    remarks: {
        fontSize: '1rem',
        borderBottom: '1px solid #ccc',
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    }
}));
export default function ConfirmItecEmp({ row, deleteRow, tennantName, pageName }) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    const [open, setOpen] = React.useState(false);
    const [enterRemark, setenterRemark] = React.useState();
    const [showLoader, setShowLoader] = useState(false);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [count, setCount] = useState();
    const [servives, setServices] = useState([]);
    const [deleteEmpConfirm, setDeletEmpConfirm] = useState(false)
    const [deleteEmpFlag, setDeletEmpFlag] = useState();
    const [assignEmpOpen, setAssignEmpOpen] = React.useState(false);

    // const noOfServices = location.state.row;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const handleClickOpen = () => {
        //console.log("row", row);
        if (pageName === "core") {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/getEmployeeServicesCount/${tennantName}/${row.empId}`, axiosConfig)
                .then((response) => {
                    //console.log("response", response.data);
                    const empCount = response.data;
                    setCount(empCount)
                    if (empCount > 0) {
                        //console.log("Aasrush ==>>>>>handleClickOpen", empCount);
                        setOpen(true);
                    } else {
                        setOpen(false);
                        setDeletEmpConfirm(true);
                    }
                })
                .catch((error) => {
                    //console.log(error);
                })
        } else {
            setOpen(false);
            setDeletEmpConfirm(true);
        }
    };

    const handleDeleteEmp = () => {
        setDeletEmpConfirm(false)
        deleteRow(row);
    }

    useEffect(() => {
        // /getEmployeeServices/{ tennantName } /{ id} 
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/getEmployeeServices/${tennantName}/${row.empId}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log('response.Chandra', response);
                setServices(response.data);
            })
            .catch((error) => { });
    }, [bearerToken]);

    const handleDelete = () => {
        setShowLoader(true);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee_delete/${row.itecEmpId}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                console.log('response', response);
                setDeletEmpFlag(response.data)
                setShowLoader(false);
                if (response && !response.data) {
                    setAssignEmpOpen(true);
                } else {
                    handleClickOpen();
                }
            })
            .catch((error) => { });
    }

    const handleClose = () => {
        setOpen(false);
        setDeletEmpConfirm(false)
        setShowLoader(false);
    };
    const handleOk = () => {
        // console.log('loader141',setShowLoader(true));
        history.push({
            pathname: '/menu/deleteEmp',
            state: { row, servives, tennantName }
        });
        setShowLoader(true);
        setTimeout(() => {
            setOpen(false);
            setShowLoader(false);
        }, 1500);

    };

    const handleAssign = () => {
        history.push({
            pathname: '/menu/imc-itec-emp',
            state: { row }
        });
    }

    const remarkValue = (e) => {
        setenterRemark(e.target.value);
    };

    return (
        <>
            {showLoader ? (<LoaderPopUp showLoader={showLoader} handleClose={handleClose} />) : null}

            <Tooltip title="Delete" onClick={handleDelete}>
                <IconButton aria-label="delete">
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
            {open && <Dialog
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Please confirm
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        Are you sure you want to delete this record? If yes, assign their pending tasks to other employee before deleting the employee.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>

                    <Button onClick={() => handleClose()} variant="outlined" color="primary" size="small" className={classes.btnBluepop} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={() => handleOk(row)} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        {/* Ok */}
                        Assign pending task
                    </Button>
                </DialogActions>
            </Dialog>}
            {deleteEmpConfirm && <Dialog
                open={deleteEmpConfirm}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Please confirm
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        Are you sure you want to delete this record? If yes, press Ok or press Cancel to go back.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => handleClose()} variant="outlined" color="primary" size="small" className={classes.btnBluepop} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteEmp(row)} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        {/* Ok */}
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>}
            <Dialog
                open={assignEmpOpen}
                onClose={() => setAssignEmpOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Please confirm
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        Are you sure you want to delete this record? If yes, assign the pending tasks to any other employee and delete it.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>

                    <Button onClick={() => setAssignEmpOpen(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={() => handleAssign(row)} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        {/* Ok */}
                        Assign pending tasks
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}